module.exports = __webpack_public_path__ + "static/media/097-clockNeedles.9fda6824.svg";